import { TOGGLE_DRAWER, SET_DRAWER } from './SideBarDrawerActionType'

const initialState = {
  drawerOpen: true // or false depending on default
}

export default function layoutReducer (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_DRAWER:
      return { ...state, drawerOpen: !state.drawerOpen }
    case SET_DRAWER:
      return { ...state, drawerOpen: action.payload }
    default:
      return state
  }
}
